import { Navigate, Outlet } from 'react-router-dom'
import { useAuthToken } from 'hooks'
import { PlaceHolder } from 'components'

const PublicRoutesOutlet = () => {
  const { loading, isAuthenticated } = useAuthToken()
  if (loading) return <PlaceHolder />
  return isAuthenticated ? <Navigate to="/" /> : <Outlet />
}

export default PublicRoutesOutlet
